module.exports = {
  title: process.env["VUE_APP_WEB_TITLE"],
  index_title: process.env["VUE_APP_WEB_TITLE"],
  logo: process.env["VUE_APP_SHOW_LOGO_URL"],
  show_logo: process.env["VUE_APP_SHOW_LOGO"] == "1",
  show_old: process.env["VUE_APP_SHOW_OLD"] == "1",
  open_vip_buy: process.env["VUE_APP_SHOW_VIP_BUY"] == "1",
};
